import { render, staticRenderFns } from "./ActividadCompletarFooter.vue?vue&type=template&id=fd800678&scoped=true"
import script from "./ActividadCompletarFooter.vue?vue&type=script&lang=js"
export * from "./ActividadCompletarFooter.vue?vue&type=script&lang=js"
import style0 from "./ActividadCompletarFooter.vue?vue&type=style&index=0&id=fd800678&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd800678",
  null
  
)

export default component.exports